import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"


const API_KEY = process.env.REACT_APP_apiKey;
const GATEWAY_URL = process.env.REACT_APP_GATEWAY_URL;

const isObject = (obj) => {
    return typeof obj === 'object' && !Array.isArray(obj) && obj !== null;
}

const objToArray = (obj) => {
    return Object.keys(obj).map((key) => {
        return [
            key, isObject(obj[key]) ?
                objToArray(obj[key]) :
                obj[key]
        ];
    });
}

// Define a service using a base URL and expected endpoints
export const btelbApi = createApi({
    reducerPath: 'btelbApi',
    baseQuery: fetchBaseQuery({
        baseUrl: GATEWAY_URL,
        prepareHeaders: (headers, { getState }) => {

            // If we have a token set in state, let's assume that we should be passing it.
            return headers
        },
        }),
    mode: "cors",
    tagTypes: ['client-api'],
    endpoints: (build) => ({
        findAllCompanies: build.query({
            query: (args) => ({ url: `companies/?apiKey=${args.apiKey}`,
            headers: {'authorization': `Bearer ${args.token}`},
            transformResponse: (response) =>{
                return  objToArray(response.data)
            } ,
            method: 'GET' }),
        }),
        findCompanyById: build.query({
            query: (args) => ({
                providesTags: ['companies'],
                url: `companies/${args.companyId}/?apiKey=${args.apiKey}`,
                headers: {'authorization': `Bearer ${args.token}`},
                transformResponse: (response) =>{
                    return  response.data
                } ,
                method: 'GET' }),
        }),
        findAllUsers: build.query({
            query: (args) => ({
                providesTags: ['companies'],
                url: `users/?apiKey=${args.apiKey}&companyId=${args.companyId}`,
                headers: {'authorization': `Bearer ${args.token}`},
                transformResponse: (response) =>{
                    return  objToArray(response.data)
                } ,
                method: 'GET' }),
        }),
        getSettings: build.query({
            query: (args) => ({
                url: `users/current/settings/?apiKey=${args.apiKey}`,
                providesTags: ['Settings'],
                headers: {'authorization': `Bearer ${args.token}`},
                transformResponse: (response) =>{
                    return  response.data
                } ,
                method: 'GET' }),
        }),
        updateSettings: build.mutation({
            invalidatesTags: ['Settings'],
            tagTypes: ['Settings'],
            query(args) {
                const {...body } = args.data
                return {
                    url: `users/current/settings/?apiKey=${args.apiKey}`,
                    headers: {'authorization': `Bearer ${args.token}`},
                    method: 'PATCH',
                    body,
                }
            },
            // Invalidates all queries that subscribe to this Post `id` only.
            // In this case, `getPost` will be re-run. `getPosts` *might*  rerun, if this id was under its results.
            // invalidatesTags: (result, error, { id }) => [{ type: 'Posts', id }],
        }),
        createUser: build.mutation({
            invalidatesTags: ['Users'],
            tagTypes: ['Users'],
            query(args) {
                const {...body } = args.data
                return {
                    url: `users/?apiKey=${args.apiKey}`,
                    headers: {'authorization': `Bearer ${args.token}`},
                    method: 'POST',
                    body,
                }
            },
            // Invalidates all queries that subscribe to this Post `id` only.
            // In this case, `getPost` will be re-run. `getPosts` *might*  rerun, if this id was under its results.
            // invalidatesTags: (result, error, { id }) => [{ type: 'Posts', id }],
        }),
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined btelbApi
export const { useFindAllCompaniesQuery, useFindCompanyByIdQuery, useFindAllUsersQuery, useGetSettingsQuery,
    useUpdateSettingsMutation, useCreateUserMutation }
    = btelbApi